"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PonziDepositStatus = void 0;
var PonziDepositStatus;
(function (PonziDepositStatus) {
    PonziDepositStatus["ACTIVE"] = "ACTIVE";
    PonziDepositStatus["CANCELED"] = "CANCELED";
    PonziDepositStatus["COMPLETE"] = "COMPLETE";
})(PonziDepositStatus || (exports.PonziDepositStatus = PonziDepositStatus = {}));
//# sourceMappingURL=deposit.js.map